<template>
  <div ref="documentScroll" class="document__viewer">
    <loader-dots v-if="isLoading.info" #text>
      Загрузка документа...
    </loader-dots>

    <div v-else-if="loadErrors.info.status" class="message _error">
      {{
        `${
          loadErrors.info.message === 'Request failed with status code 403'
            ? 'Документ недоступен в веб-интерфейсе'
            : 'Ошибка:' + loadErrors.info.message
        }`
      }}
    </div>

    <template v-else-if="currentView === 'html'">
      <document-html-viewer
        v-if="hasFormatHtml"
        :document-id="documentId"
        :fragment-id="fragmentId"
        :card="card"
      />
      <p v-else>Текст документа отсутствует.</p>
    </template>

    <template v-else-if="currentView === 'scan'">
      <document-scan-viewer
        v-if="hasFormatScan && pages.length"
        :pages="pages"
        :document-id="documentId"
        :fragment-id="fragmentId"
        :marks="searchMatches"
      />

      <div v-if="!hasFormatScan">
        <p>Скан документа отсутствует.</p>
        <router-link
          v-if="hasFormatHtml"
          :to="documentTextRoute"
          class="rli__link"
        >
          Посмотреть документ в текстовом формате
        </router-link>
      </div>
    </template>

    <template v-else-if="currentView === 'views'">
      <document-both-viewer
        :pages="pages"
        :fragment-id="fragmentId"
      />
    </template>

    <document-card-viewer v-else :card="card" :target="$route.hash" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import LoaderDots from '@@/shared/loaders/LoaderDots';
import DocumentHtmlViewer from './DocumentHtmlViewer';
import DocumentScanViewer from './DocumentScanViewer';
// import DocumentBothViewer from './DocumentBothViewer';

export default {
  components: {
    LoaderDots,
    DocumentHtmlViewer,
    DocumentScanViewer,
    DocumentBothViewer: () => import('./DocumentBothViewer'),
    DocumentCardViewer: () => import('./DocumentCardViewer')
  },

  props: {
    fragmentId: {
      type: String
    },
    currentView: {
      type: String
    },
    searchMatches: {
      type: Object
    },
    pages: {
      type: Array,
      default: () => []
    }
  },

  computed: {
    ...mapGetters({
      documentId: 'currentDocumentId',
      card: 'currentDocumentInfo',
      isLoading: 'documentIsLoading',
      loadErrors: 'loadErrors'
    }),
    hasFormatHtml() {
      return this.card && this.card.hasFormatHtml();
    },
    hasFormatScan() {
      return this.card && this.card.hasFormatScan();
    },
    documentTextRoute() {
      return `/document/${this.documentId}/${this.hasFormatHtml ? 'html' : ''}`;
    }
  }
};
</script>
